// extracted by mini-css-extract-plugin
export default {"yearContainer":"YearPublications_yearContainer__rDk1D","publications":"YearPublications_publications__2T7na"};